export default __webpack_public_path__ + "static/media/le_neubourgmini.f0db24e1.jpg";